import { environment } from '../../../environments/environment';

type MediaEnv = {
  mediaCdnOrigin?: string;
  mediaApiUrl?: string;
  mediaOrigin?: string;
  backendUrl?: string;
  apiUrl?: string;
};

function env(): MediaEnv {
  return environment as MediaEnv;
}

/** Public origin for `/uploads/...` (CDN when configured). */
export function getMediaUploadOrigin(): string {
  const cdn = env().mediaCdnOrigin?.trim().replace(/\/+$/, '');
  if (cdn) {
    return cdn;
  }

  if (!environment.production) {
    const devOrigin = env().mediaOrigin?.trim().replace(/\/+$/, '') || env().backendUrl?.trim().replace(/\/+$/, '');
    if (devOrigin) {
      return devOrigin;
    }
  }

  return environment.apiUrl.replace(/\/api\/?$/, '') || '';
}

/** API base for `GET /media/image` variant URLs (CDN or production in dev). */
export function getMediaApiBase(): string {
  const cdn = env().mediaCdnOrigin?.trim().replace(/\/+$/, '');
  if (cdn) {
    return `${cdn}/api`;
  }

  if (!environment.production) {
    const mediaApi = env().mediaApiUrl?.trim().replace(/\/+$/, '');
    if (mediaApi) {
      return mediaApi;
    }
    const backend = env().backendUrl?.trim().replace(/\/+$/, '');
    if (backend) {
      return `${backend}/api`;
    }
  }

  return environment.apiUrl.replace(/\/+$/, '') || '/api';
}
